// extracted by css-extract-rspack-plugin
export default {"root":"root-qQgUUn","main":"main-TIXFN0","active":"active-uBX9oG","menu":"menu-ObfwCp","link":"link-zby3Dd","githubSvg":"githubSvg-vkcqMP","logo":"logo-SrtenO"};